import { MedicalAnalysesGroup } from "./medical-analyses";

export class WorkerMedicalAnalyses {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.positions = data.posts.map((post) => post.name) || [];
        this.filial = data.filial.filial_name;

        const groups = [];

        data.workerAnalyses.forEach((group) => {
            if (group) {
                groups.push(new MedicalAnalysesGroup(group));
            }
        });

        this.analyseGroups = groups;
    }
}
